import { INotationWidgetState } from './Interfaces/INotationWidgetState';
import { DispatchActions } from './Types/NotationWidgetDispatchActions';
import { NotationWidgetActionType } from './Types/NotationWidgetActionType';

export const NotationWidgetReducer = (
  state: INotationWidgetState,
  action: DispatchActions,
): INotationWidgetState => {
  switch (action.type) {
    case NotationWidgetActionType.SetTitleText:
      return { ...state, titleText: action.value };
    case NotationWidgetActionType.SetDescriptionText:
      return { ...state, descriptionText: action.value };
    case NotationWidgetActionType.SetHeight:
      return { ...state, height: action.value };
    case NotationWidgetActionType.SetWidth:
      return { ...state, width: action.value };
    case NotationWidgetActionType.SetIsLoading:
      return { ...state, isLoading: action.value };
    case NotationWidgetActionType.SetCurrentStep:
      return { ...state, currentStep: action.value };
    case NotationWidgetActionType.SetInitialData:
      return {
        ...state,
        id: action.id,
        institutionId: action.institutionId,
        createdById: action.createdById,
        createdOn: action.createdOn,
        modifiedById: action.modifiedById,
        titleText: action.titleText,
        descriptionText: action.descriptionText,
        height: action.height,
        width: action.width,
        alertPermissions: action.alertPermissions,
        updatePermissions: action.updatePermissions,
        encouragementPermissions: action.encouragementPermissions,
      };
    case NotationWidgetActionType.SetAlertPermissions: {
      var alertPerm = state.alertPermissions;
      alertPerm[action.permission] = action.value;
      return { ...state, alertPermissions: alertPerm };
    }
    case NotationWidgetActionType.SetUpdatePermissions: {
      var updatePerm = state.updatePermissions;
      updatePerm[action.permission] = action.value;
      return { ...state, updatePermissions: updatePerm };
    }
    case NotationWidgetActionType.SetEncouragementPermissions: {
      var encouragementPerm = state.encouragementPermissions;
      encouragementPerm[action.permission] = action.value;
      return { ...state, encouragementPermissions: encouragementPerm };
    }
    default:
      return state;
  }
};
